import React from 'react';

import Lottie from 'react-lottie-player';
import animationData from 'Shared/spiner_blue.json';

function LottieTable({ dataTestId }) {
  return (
    <Lottie
      data-testid={dataTestId}
      className="lottie"
      loop={true}
      play={true}
      animationData={animationData}
      width={100}
      style={{
        width: 100,
        height: 100,
        margin: '0px auto',
        position: 'absolute',
        top: 'calc(50% - 50px)',
        left: 'calc(50% - 50px)',
        zIndex: 1,
      }}
    />
  );
}

export default LottieTable;
